<template>
  <div class="flex items-center justify-between" style="box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06)">
    <button
      id="left-tab"
      class="w-full flex-1 flex h-full pv-12 space-x-2 bg-white items-center justify-center"
      @click="$emit('leftTabClick')"
    >
      <div class="relative">
        <IcoLocationMinor />
        <IconGreenCheck
          v-if="getIsUsingLocationFilter"
          data-testid="location-green-check"
          class="absolute"
          style="bottom: 0; right: -2px"
        />
      </div>
      <BlTextAv variation="caption-12" weight="medium" color="secondary">Lokasi</BlTextAv>
    </button>

    <div class="vertical-divider mx-4"></div>

    <button
      id="middle-tab"
      class="w-full flex-1 flex h-full pv-12 space-x-2 bg-white items-center justify-center"
      @click="$emit('middleTabClick')"
    >
      <div class="relative">
        <IcoFilterMinor />
        <IconGreenCheck v-if="isUsingFilter" data-testid="filter-green-check" class="absolute" style="bottom: 0; right: -2px" />
      </div>
      <BlTextAv variation="caption-12" weight="medium" color="secondary">Filter</BlTextAv>
    </button>

    <div class="vertical-divider mx-4"></div>

    <button
      id="right-tab"
      class="w-full flex-1 flex h-full pv-12 space-x-2 bg-white items-center justify-center"
      @click="$emit('rightTabClick')"
    >
      <div class="relative">
        <IcoSortMinor />
        <IconGreenCheck class="absolute" style="bottom: 0; right: -2px" />
      </div>
      <BlTextAv id="sort-value" variation="caption-12" weight="medium" color="secondary">{{ currentActiveSort }}</BlTextAv>
    </button>
  </div>
</template>

<script>
import {IcoFilterMinor, IcoSortMinor, IcoLocationMinor} from '@bukalapak/bazaar-visual-next';
import {BlTextAv} from '@bukalapak/bazaar-mweb-latest';
import {mapGetters} from 'vuex';
import omit from 'lodash/omit';

import IconGreenCheck from '../shared/IconGreenCheck.vue';

export default {
  name: 'PrakerjaFilterSortTab',
  components: {
    IcoFilterMinor,
    IcoSortMinor,
    IconGreenCheck,
    IcoLocationMinor,
    BlTextAv,
  },
  computed: {
    ...mapGetters('courses', [
      'getCoursesFilter',
      'getIsUsingFilter',
      'getSortCourseOptions',
      'getSortCoursesBy',
      'getIsUsingLocationFilter',
    ]),
    isOnSearchPage() {
      const parentRouteName = this.$route.matched?.[0]?.name;
      return parentRouteName === 'search';
    },
    isUsingFilter() {
      if (this.isOnSearchPage) return this.getIsUsingFilter;
      return Object.values(omit(this.getCoursesFilter, ['merchants', 'keywords', 'cities', 'provinces'])).some((value) =>
        Array.isArray(value) ? value.length > 0 : !!value
      );
    },
    currentActiveSort() {
      return this.getSortCourseOptions.find((option) => option.value === this.getSortCoursesBy).name;
    },
  },
};
</script>

<style lang="scss" scoped>
.vertical-divider {
  height: 28px;
  width: 1px;
  background-color: #e8eaef;
}
</style>
